import axios from 'axios';
import baseURL from '../../Config';
export async function purchasingApi(path, method = 'GET', data, download = false) {
    const stored = JSON.parse(localStorage.getItem('userDetails') || localStorage.getItem('adminUser') || '{}');
    const token = stored?.data?.token || stored?.data?.accessToken;
    try {
        const response = await axios({ url: `${baseURL}purchasing/${path}`, method, data, headers: { Authorization: `Bearer ${token}` }, ...(download ? { responseType: 'blob' } : {}) });
        return download ? response.data : response.data.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || 'No se pudo completar la operación. Intente nuevamente.');
    }
}
